export default {
    book: 'Zarezerwuj {product}',
    age_limit: 'Tylko w wieku ponad {age}',
    upgrade_product: 'Uaktualnij produkt',
    choose_product: 'Wybierz {product}',
    days: '{count} dzień | {count} dni',
    login_register: "Login/Zarejestruj",
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Nie zgubisz kluczyka',
            zero_excess: 'Bez udziału własnego',
            phone_as_a_key: 'Telefon jako klucz',
            straight_to_car: 'Prosto do samochodu',
            no_queues: 'Bez kolejek',
            online_id_check: 'Sprawdzanie ID online',
            self_checkout: 'Samodzielny wynajem',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/pl/quotes/vehicle_card.js